import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Image as ImageIcon, Share2, Loader2 } from "lucide-react";

export default function PostcardButton({ trip, onGenerated }) {
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState(trip.postcard_url || null);

  const gen = async () => {
    setLoading(true);
    try {
      const r = await api.post(`/trips/${trip.trip_id}/postcard`);
      setUrl(r.data.postcard_url);
      onGenerated?.(r.data.postcard_url);
      toast.success(r.data.cached ? "Carte postale récupérée" : "Carte postale générée !");
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
    finally { setLoading(false); }
  };

  const share = async () => {
    const shareUrl = window.location.origin + `/search?origin=${encodeURIComponent(trip.origin.label)}&destination=${encodeURIComponent(trip.destination.label)}`;
    const text = `Je voyage ${trip.origin.label} → ${trip.destination.label} le ${new Date(trip.depart_at).toLocaleDateString("fr-FR")} sur TravelBuddy. Réservez-moi votre colis 📦`;
    try {
      if (navigator.share) {
        // Convert data URL to file for share
        if (url && url.startsWith("data:")) {
          const b = await (await fetch(url)).blob();
          const file = new File([b], "travelbuddy-postcard.png", { type: b.type });
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({ title: "TravelBuddy", text, url: shareUrl, files: [file] });
            return;
          }
        }
        await navigator.share({ title: "TravelBuddy", text, url: shareUrl });
      } else {
        await navigator.clipboard.writeText(`${text}\n${shareUrl}`);
        toast.success("Message copié — collez-le sur WhatsApp/Instagram");
      }
    } catch (e) { console.error("share", e); }
  };

  if (!url) {
    return (
      <button data-testid={`postcard-gen-${trip.trip_id}`} onClick={gen} disabled={loading} className="btn-ghost-glass px-2.5 py-1.5 rounded-lg text-xs flex items-center gap-1">
        {loading ? <Loader2 size={12} className="animate-spin"/> : <ImageIcon size={12}/>} Carte postale AI
      </button>
    );
  }
  return (
    <div className="flex flex-col gap-2">
      <img data-testid={`postcard-img-${trip.trip_id}`} src={url} alt="postcard" className="w-full max-w-[220px] rounded-lg border border-slate-700"/>
      <button data-testid={`postcard-share-${trip.trip_id}`} onClick={share} className="btn-coral px-2.5 py-1.5 rounded-lg text-xs flex items-center gap-1 self-start">
        <Share2 size={12}/> Partager
      </button>
    </div>
  );
}
